const paymentConstants = {
  PAYMENT_FETCH_CARD_LIST_STARTED: "PAYMENT_FETCH_CARD_LIST_STARTED",
  PAYMENT_FETCH_CARD_LIST_SUCCESS: "PAYMENT_FETCH_CARD_LIST_SUCCESS",
  PAYMENT_FETCH_CARD_LIST_FAILED: "PAYMENT_FETCH_CARD_LIST_FAILED",
  PAYMENT_SAVE_CARD_STARTED: "PAYMENT_SAVE_CARD_STARTED",
  PAYMENT_SAVE_CARD_SUCCESS: "PAYMENT_SAVE_CARD_SUCCESS",
  PAYMENT_SAVE_CARD_FAILED: "PAYMENT_SAVE_CARD_FAILED",

  AP_MERCHANT_VALIDATION_INITIATED: "AP_MERCHANT_VALIDATION_INITIATED",
  AP_MERCHANT_VALIDATION_SUCCESS: "AP_MERCHANT_VALIDATION_SUCCESS",
  AP_MERCHANT_VALIDATION_FAIL: "AP_MERCHANT_VALIDATION_FAIL",
  AP_SHIPPING_CONTACT_SELECTED: "AP_SHIPPING_CONTACT_SELECTED",

  PAYMENT_EDIT_CARD_SUCCESS: "PAYMENT_SAVE_CARD_SUCCESS",
  PAYMENT_EDIT_CARD: "PAYMENT_EDIT_CARD",
  PAYMENT_ADD_CARD: "PAYMENT_ADD_CARD",
  PAYMENT_CARD_VERIFY_STARTED: "PAYMENT_CARD_VERIFY_STARTED",
  PAYMENT_CARD_VERIFY_SUCCESS: "PAYMENT_CARD_VERIFY_SUCCESS",
  PAYMENT_CARD_VERIFY_FAILED: "PAYMENT_CARD_VERIFY_FAILED",
  PAYMENT_CARD_DELETE_SET: "PAYMENT_CARD_DELETE_SET",
  PAYMENT_CARD_DELETE_UNSET: "PAYMENT_CARD_DELETE_UNSET",
  PAYMENT_TYPE_APPLE_PAY: "ApplePay",
  PAYMENT_TYPE_PAYPAL: "PayPal",
  PAYMENT_SET_CARD_DETAILS_NEEDED: "PAYMENT_SET_CARD_DETAILS_NEEDED",
  PAYMENT_AFFIRM_SELECTED: "PAYMENT_AFFIRM_SELECTED",
  PAYMENT_AFFIRM_DESELECTED: "PAYMENT_AFFIRM_DESELECTED",
  PAYMENT_AFFIRM_BILLING_ADDRESS: "PAYMENT_AFFIRM_BILLING_ADDRESS",
  PAYMENT_AFFIRM_RESTRICTED_STATE: "PAYMENT_AFFIRM_RESTRICTED_STATE",
  PAYMENT_AFFIRM_ERROR: "PAYMENT_AFFIRM_ERROR",

  // EPS Check
  PAYMENT_EPS_BALANCE_CHECK_STARTED: "PAYMENT_EPS_BALANCE_CHECK_STARTED",
  PAYMENT_EPS_BALANCE_CHECK_SUCCESS: "PAYMENT_EPS_BALANCE_SUCCESS",
  PAYMENT_EPS_BALANCE_CHECK_FAILED: "PAYMENT_EPS_BALANCE_FAILED",

  PAYMENT_CS_FINGER_PRINT_SUCCESS: "PAYMENT_CS_FINGER_PRINT_SUCCESS",
  PAYMENT_CS_FINGER_PRINT_SET_SCRIPT_LOADED:
    "PAYMENT_CS_FINGER_PRINT_SET_SCRIPT_LOADED",
}

export default paymentConstants
